/**
 * 设备信息组件
 */
// import Core from '@/libs/src/core.js'
import { Style } from '@/libs/style.js';

// 获取数据处理层的provider
let DPC = null
let modules = null// DPC.modules;

let template = /*html*/ `<div class="app-monitoring">
    <div class="app-monitoring-header">
        <img src="./images/default/2.png" alt="">
        <h4>设备信息</h4>
    </div>
    <dv-scroll-board-1 :config="JSON.stringify(config)" ></dv-scroll-board-1>
</div>`;


let style = /* css */ `.app-monitoring{
    position: absolute;
    top: 100px;
    left: 1%;
    width: 25%;
    background: rgba(0,0,0,0.2);
    height: 270px;
    overflow: hidden;
}

.app-monitoring .app-monitoring-header{
    background:linear-gradient(to right,#67BDFF,rgba(0,0,0,0) 50%);
    height: 50px;
    color: #fff;
    display:flex;
    align-items:center;
}
.app-monitoring .app-monitoring-header img{
    margin:0 15px;
}
`;

export default (Vue) => {
    Vue.customElement('app-monitoring', {
        template: template,
        data() {
            return {
                config: {
                    data: [
                    ],
                    align: ['center']
                }
            }
        },
        created() {
            DPC= this.$Core.getProvider('DPC');
            modules = DPC.DPC.modules
            if (!modules) {
                DPC.proc.watch('modules', (val) => {
                    let monitor = val.filter(item => item.showType === 'monitor' || item.showType === 'enum');
                    this.setList(monitor)
                })
            } else {
                let monitor = modules.filter(item => item.showType === 'monitor' || item.showType === 'enum');
                this.setList(monitor)
            }
        },
        mounted() {
            Style(style);
        },
        methods: {
            setList(val) {

                val.forEach(item => {
                    let unit = item.unit.length > 1 ? item.unit[1] : '';
                    let displayValue = Number(item.displayValue) ? Number(item.displayValue).toFixed(2) : item.displayValue;
                    let itemArr = [item.className, item.controlName, displayValue + ' ' + unit];
                    this.config.data.push(itemArr)
                })
            }
        }
    });
}